import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import BedRoundedIcon from "@mui/icons-material/BedRounded";
import AspectRatioRoundedIcon from "@mui/icons-material/AspectRatioRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import oneBed480 from "../assets/1-bed-480.png";
import oneBed580 from "../assets/1-bed-580.png";
import studio1 from "../assets/studio1.png";
import studio2 from "../assets/studio2.png";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./Residences.css";
import openWhatsApp from "../utils/sendWhatsapp";

const units = [
  {
    title: "1 Bed Executive",
    size: "480 sqft",
    beds: "1 Bedroom",
    price: "Starting from 15000/sq.ft",
    img: oneBed480,
    tag: "Most Popular",
  },
  {
    title: "1 Bed Premium",
    size: "580 sqft",
    beds: "1 Bedroom",
    price: "Starting from 15000/sq.ft",
    img: oneBed580,
    tag: "Best Value",
  },
  {
    title: "Studio",
    size: "330 sqft",
    beds: "1 Bedroom",
    price: "Starting from 15000/sq.ft",
    img: studio1,
    tag: "Spacious",
  },
  {
    title: "Studio",
    size: "335 sqft",
    beds: "Luxury Living",
    price: "Starting from 15000/sq.ft",
    img: studio2,
    tag: "Signature",
  },
];

const Residences = () => {
  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  return (
    <section className="res" id="residences" ref={ref}>
      <div className="res__container">
        <motion.div
          className="res__head"
          initial={{ opacity: 0, y: 14 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <div className="res__kicker">RESIDENCES</div>
          <h2 className="res__title">Choose the space that fits your life.</h2>
          <p className="res__sub">
            Thoughtful layouts, premium finishes, and natural light — designed
            for everyday comfort.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7, delay: 0.08 }}
        >
          <Swiper
            modules={[Pagination, Autoplay]}
            // navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 2800, disableOnInteraction: false }}
            spaceBetween={14}
            slidesPerView={3}
            breakpoints={{
              0: { slidesPerView: 1.05 },
              520: { slidesPerView: 1.4 },
              820: { slidesPerView: 2.2 },
              1100: { slidesPerView: 3 },
            }}
            className="res__swiper"
          >
            {units.map((u, idx) => (
              <SwiperSlide key={idx}>
                <div className="res__card">
                  <div className="res__imgWrap">
                    <img
                      src={u.img}
                      alt={u.title}
                      className="res__img"
                      loading="lazy"
                    />
                    <div className="res__tag">{u.tag}</div>
                  </div>

                  <div className="res__body">
                    <div className="res__row">
                      <h3 className="res__cardTitle">{u.title}</h3>
                      <button
                        onClick={() => {
                          openWhatsApp();
                        }}
                        className="res__linkBtn"
                        type="button"
                      >
                        <span>Details</span>
                        <ArrowOutwardRoundedIcon />
                      </button>
                    </div>

                    <div className="res__meta">
                      <div className="res__metaItem">
                        <AspectRatioRoundedIcon />
                        <span>{u.size}</span>
                      </div>
                      <div className="res__metaItem">
                        <BedRoundedIcon />
                        <span>{u.beds}</span>
                      </div>
                      <div className="res__metaItem">
                        <PaymentsRoundedIcon />
                        <span>{u.price}</span>
                      </div>
                    </div>

                    <div className="res__note">
                      Flexible installment options available. Contact us for
                      floor plans.
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </section>
  );
};

export default Residences;
